/**
 * Employee Data Registry
 * Structure: [slug]: { name, role, company, id, phone, email, website, linkedin, whatsapp, profileImage, bio }
 */
export const employees = {
  "arunava-maity": {
    name: "Arunava Maity",
    role: "Head of Operation, UK",
    company: "Arc Engineering Solutions Ltd",
    id: "ARC-101-AM",
    phone: "+44 7492949230",
    email: "arun@arcengltd.com",
    website: "https://www.arcengltd.com/",
    linkedin: "www.linkedin.com/in/arunava-maity-6236a017/",
    whatsapp: "447492949230",
    profileImage: "https://res.cloudinary.com/dc912sjxj/image/upload/c_fill,g_face,w_400,h_400,f_auto,q_auto/v1772547762/maity-arunava_AGP_People_quyu6u.webp",
    bio: "Global Energy Executive (MBA, PMP) | Scaling High-Value Power Generation Projects.",
  },
  "m-lalan": {
    name: "M. Lalan",
    role: "Head of Sales and BD, UK",
    company: "Arc Engineering Solutions Ltd",
    id: "ARC-102-ML",
    phone: "+44 7743977718",
    email: "lalan@arcengltd.com",
    website: "https://www.arcengltd.com/",
    linkedin: "https://www.linkedin.com/in/mlalan/",
    whatsapp: "447743977718",
    profileImage: "https://res.cloudinary.com/dc912sjxj/image/upload/c_fill,g_face,w_400,h_400,f_auto,q_auto/v1772547529/lalan-m_AGP_People_uztnoc.webp",
    bio: "MBA | Global energy leader delivering Net Zero value through strategic partnerships, cost focus, and UK operations.",
  },
};